import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import axios from "axios";

import { OhCaseDetailModel, parseOhCaseModel } from "../crud/ohCase/model";
import { TaskType } from "../task/model";

import { CreateMHPCaseTreatmentModel } from "./models";

const baseApiUrl = "/api/mentalHealthPractitionerTreatmentCase";

const create = async (createModel: CreateMHPCaseTreatmentModel) => {
    const response = await axios.post<ServerModelWithDateStrings<OhCaseDetailModel>>(baseApiUrl, createModel);
    return parseOhCaseModel(response.data);
};

const getTaskTypes = async (): Promise<TaskType[]> => {
    const response = await axios.get<TaskType[]>(`${baseApiUrl}/taskTypes`);
    return response.data;
};

export const mhpTreatmentCaseApi = { create, getTaskTypes };
